import { PublishedWorkEditWorkloadImpact } from '@/viewmodels';
import { WorkloadStatus } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/workload_status_pb';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import LocalizedStrings from 'strings';
import { Banner } from '../../utils';
import { PublishedWorkEditWorkloadImpactIndicatorPopover } from './PublishedWorkEditWorkloadImpactIndicatorPopover';

export interface PublishedWorkEditWorkloadImpactIndicatorProps {
  sx?: SxProps;
  className?: string;
  workloadImpact: PublishedWorkEditWorkloadImpact;
}

export const PublishedWorkEditWorkloadImpactIndicator = observer(
  ({ className, sx = [], workloadImpact }: PublishedWorkEditWorkloadImpactIndicatorProps) => {
    const [workloadImpactDetailsAnchor, setWorkloadImpactDetailsAnchor] = useState<HTMLElement | null>(null);
    const strings = LocalizedStrings.publishedWork.edit;

    return (
      <Box sx={sx} className={className}>
        <Banner
          onClick={(e) => setWorkloadImpactDetailsAnchor(e.currentTarget)}
          severity={workloadImpact.highestStatus === WorkloadStatus.AT_THRESHOLD ? 'warning' : 'error'}
        >
          {workloadImpact.highestStatus === WorkloadStatus.AT_THRESHOLD
            ? strings.workloadImpactAtThresholdLabel(workloadImpact.numberOfStudentsForHighestStatus)
            : strings.workloadImpactAboveThresholdLabel(workloadImpact.numberOfStudentsForHighestStatus)}
        </Banner>

        {workloadImpactDetailsAnchor != null && (
          <PublishedWorkEditWorkloadImpactIndicatorPopover
            isOpen
            workloadImpact={workloadImpact}
            onClose={() => setWorkloadImpactDetailsAnchor(null)}
            anchorEl={workloadImpactDetailsAnchor}
          />
        )}
      </Box>
    );
  }
);
